var render, staticRenderFns
import script from "./XlsxSheet.vue?vue&type=script&lang=js&"
export * from "./XlsxSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports